import moment from 'moment';

export function getDayDiff(startDate: moment.Moment, endDate: moment.Moment): number {
  return endDate.diff(startDate, 'days');
}
